import { GetQualifiedInvoiceDetailPaymentQuery } from "@graffer-inc/smart-apply";
import { formatAmount } from "@graffer-inc/cloud-gov-core";
import { matchType } from "../../../../application/domain/base/base-type";

type Props = {
  buyerName?: string;
  businessIssuer: {
    name: string;
    registrationNumber: string;
  };
  transactionDate: string;
  detailPayment: NonNullable<
    GetQualifiedInvoiceDetailPaymentQuery["qualifiedInvoiceDetailPayment"]
  >;
};

export const PreviewQualifiedInvoice: React.FC<Props> = ({
  buyerName,
  businessIssuer: { name, registrationNumber },
  transactionDate,
  detailPayment: { items, amount, amountDetail, taxAmountDetail },
}) => {
  return (
    <div className="item-box item-box-list">
      <div className="is-flex is-justify-content-center is-align-items-center mt-2 is-4 has-text-weight-bold">
        <p style={{ fontSize: "24px" }}>支払い明細書</p>
      </div>
      <div className="is-flex is-justify-content-space-between mt-6">
        <div
          className={`pr-4 is-flex is-flex-shrink-1 is-flex-grow-1 ${
            buyerName ? "is-flex-direction-column" : ""
          }`}
          style={{ maxWidth: "50%" }}
        >
          {!!buyerName && (
            <p style={{ wordBreak: "break-word" }}>{buyerName}</p>
          )}
          <p className={`${buyerName ? "mt-2" : ""}`}>
            取引年月日: {transactionDate}
          </p>
        </div>
        <div
          className="pl-4 is-flex is-flex-direction-column is-flex-shrink-1 is-flex-grow-1 has-text-right"
          style={{ maxWidth: "50%" }}
        >
          <p style={{ wordBreak: "break-word" }}>{name}</p>
          <p className="mt-2">登録番号: {registrationNumber}</p>
        </div>
      </div>
      <table className="table is-fullwidth is-marginless c-border mt-6">
        <thead>
          <tr>
            <th style={{ width: "50%" }}>費目</th>
            <th style={{ width: "30%" }}>税区分</th>
            <th className="has-text-right">金額</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={`qualified-invoice-detail-payment-table-row${idx}`}>
              <td>{item.description}</td>
              <td>
                {matchType(item.taxRate, {
                  "0": "非課税",
                  "0.1": "10%",
                  "0.08": "8%",
                })}
              </td>
              <td className="has-text-right">{formatAmount(item.amount)}円</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="columns mt-6 px-3">
        <div className="column is-three-fifth"></div>
        <div className="column">
          <dl className="is-flex is-justify-content-space-between is-align-items-center mb-2">
            <dt className="sum is-4 is-size-4-mobile is-size-4-desktop has-text-weight-bold">
              <span>合計</span>
            </dt>
            <dd className="sum is-size-3-mobile is-size-3-desktop has-text-weight-bold">
              <span>
                {formatAmount(amount)}
                <span className="ml-1 is-size-6">円</span>
              </span>
            </dd>
          </dl>
          <div style={{ borderTop: "1px solid lightgrey" }} />
          <div className="is-flex is-flex-direction-column">
            {!!amountDetail["0"] && (
              <div className="is-flex is-justify-content-space-between is-align-items-center mt-2">
                <dt>
                  <span>非課税</span>
                </dt>
                <dd>
                  <span>
                    {formatAmount(amountDetail["0"])}
                    <span className="ml-1 is-size-6">円</span>
                  </span>
                </dd>
              </div>
            )}
            {!!amountDetail["0.1"] && (
              <div className="is-flex is-justify-content-space-between is-align-items-center mt-2">
                <dt>
                  <span>税率10%対象</span>
                </dt>
                <dd>
                  <span>
                    {formatAmount(amountDetail["0.1"])}
                    <span className="ml-1 is-size-6">円</span>
                  </span>
                </dd>
              </div>
            )}
            {/* 消費税額は0円の場合でも補正を行う可能性があるので0円以上を表示可能な条件とする */}
            {!!amountDetail["0.1"] && taxAmountDetail["0.1"] >= 0 && (
              <div className="is-flex is-justify-content-space-between is-align-items-center mt-2">
                <dt>
                  <span className="has-text-grey-dark">うち税額</span>
                </dt>
                <dd>
                  <span>
                    {formatAmount(taxAmountDetail["0.1"])}
                    <span className="ml-1 is-size-6">円</span>
                  </span>
                </dd>
              </div>
            )}
            {!!amountDetail["0.08"] && (
              <div className="is-flex is-justify-content-space-between is-align-items-center mt-2">
                <dt>
                  <span>税率8%対象</span>
                </dt>
                <dd>
                  <span>
                    {formatAmount(amountDetail["0.08"])}
                    <span className="ml-1 is-size-6">円</span>
                  </span>
                </dd>
              </div>
            )}
            {!!amountDetail["0.08"] && taxAmountDetail["0.08"] >= 0 && (
              <div className="is-flex is-justify-content-space-between is-align-items-center mt-2">
                <dt>
                  <span className="has-text-grey-dark">うち税額</span>
                </dt>
                <dd>
                  <span>
                    {formatAmount(taxAmountDetail["0.08"])}
                    <span className="ml-1 is-size-6">円</span>
                  </span>
                </dd>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
